import { useChatContext } from '../../../../../contexts/ChatContext';
import ChatMessage from './ChatMessage';
import PreviousTranscriptButton from './PreviousTranscriptButton';
import { Box, Typography, Divider } from '@coolblue-development/freddy';

const PersistentChatContainer = (): JSX.Element | null => {
  const { previousChatMessagesByContact, selectedChat } = useChatContext();

  if (!selectedChat) return null;

  const filteredPreviousChatMessages = previousChatMessagesByContact[selectedChat] || [];

  return (
    <>
      {filteredPreviousChatMessages.length > 0 && (
        <Divider data-testid="persistent-chat-divider">
          <Typography sx={{ color: '#666666', padding: '0px 10px' }}>Today</Typography>
        </Divider>
      )}
      {filteredPreviousChatMessages.map((item, index) => (
        <ChatMessage key={index} chatMessage={item} />
      ))}
      <Box sx={{ textAlign: 'center' }}>
        <PreviousTranscriptButton />
      </Box>
    </>
  );
};

export default PersistentChatContainer;
